// Site data — Hays Holdings: manufacturer distribution & Amazon growth partner

const CRL_LOGO = "/brands/crl.png";
const HAWKINS_LOGO = "/brands/hawkins.svg";

// Current brand partners — ONLY these two are shown.
export const PARTNERS = [
  {
    name: "CRL",
    full: "C.R. Laurence",
    logo: CRL_LOGO,
    website: "https://www.crlaurence.com/",
  },
  {
    name: "Hawkins",
    full: "Hawkins",
    logo: HAWKINS_LOGO,
    website: "https://hawkinscookers.com/",
  },
];

// Section 2 — Why brands partner with Hays Holdings
export const PARTNER_BENEFITS = [
  {
    icon: "TrendingUp",
    title: "Amazon Marketplace Expertise",
    desc: "We grow brands on Amazon — optimized listings, advertising strategy, and ranking that turns catalogs into revenue.",
  },
  {
    icon: "Truck",
    title: "Distribution Infrastructure",
    desc: "A national distribution network and fulfillment operation that gets your products to the right channels, fast.",
  },
  {
    icon: "Boxes",
    title: "Inventory Management",
    desc: "Demand forecasting and inventory planning that keeps your products in stock and selling, never stranded.",
  },
  {
    icon: "ShieldCheck",
    title: "Brand Protection",
    desc: "MAP enforcement, listing control, and pricing integrity that protect your brand equity across every channel.",
  },
  {
    icon: "LineChart",
    title: "Revenue Growth",
    desc: "We're measured by your sales. Our entire model is built around growing your top line, not just holding stock.",
  },
  {
    icon: "Handshake",
    title: "Long-Term Partnership",
    desc: "A strategic, long-term relationship focused on building durable market presence — not one-off transactions.",
  },
];

// Section 3 — how we sell (Amazon + our own distribution channels)
export const AMAZON_CAPABILITIES = [
  { icon: "ShoppingCart", title: "Amazon Marketplace Selling", desc: "We sell your products directly on Amazon with optimized listings, advertising, and ranking." },
  { icon: "Truck", title: "Our Own Distribution Channels", desc: "We move volume through our established national distribution network and wholesale accounts." },
  { icon: "ListChecks", title: "Catalog Optimization", desc: "Titles, content, imagery, and SEO optimized to convert and rank across every channel." },
  { icon: "PackageSearch", title: "Inventory Forecasting", desc: "Data-driven forecasting to prevent stockouts and keep products selling everywhere." },
  { icon: "Network", title: "Multi-Channel Expansion", desc: "Expand into Walmart, ecommerce, and additional marketplaces beyond Amazon." },
  { icon: "TrendingUp", title: "Revenue Growth", desc: "Every channel and lever pulled toward measurable, compounding sales growth." },
];

// Section 5 — What we look for in a brand partner
export const WHAT_WE_LOOK_FOR = [
  { icon: "Truck", title: "Expand Distribution", desc: "Brands ready to reach more channels and customers nationwide." },
  { icon: "ShoppingCart", title: "Grow Online Sales", desc: "Manufacturers looking to scale their ecommerce and online revenue." },
  { icon: "TrendingUp", title: "Improve Amazon Performance", desc: "Products that can win bigger on Amazon with expert management." },
  { icon: "Network", title: "Enter New Channels", desc: "Brands wanting to open marketplaces and channels they don't reach today." },
  { icon: "LineChart", title: "Scale Revenue", desc: "Companies focused on sustainable, measurable revenue growth." },
  { icon: "Building2", title: "Build Long-Term Presence", desc: "Manufacturers seeking a durable, strategic market position." },
];

// Section 6 — Partnership process
export const PROCESS_STEPS = [
  { title: "Brand Evaluation", desc: "We learn your products, goals, and current channels to assess fit and opportunity." },
  { title: "Market Opportunity Analysis", desc: "We map demand, competition, and pricing to size the real growth opportunity." },
  { title: "Distribution Strategy", desc: "We design the distribution and fulfillment plan to move your products efficiently." },
  { title: "Marketplace Expansion", desc: "We launch and optimize Amazon and additional channels to drive sales." },
  { title: "Long-Term Growth Partnership", desc: "We manage, protect, and grow your brand as an ongoing strategic partner." },
];

export const STATS = [
  { value: "$12M+", label: "Amazon Revenue Generated" },
  { value: "1,000,000+", label: "Products Distributed" },
  { value: "National", label: "Distribution Network" },
  { value: "Long-Term", label: "Brand Partnerships" },
];

export const PRODUCT_CATEGORIES = [
  "Door & Hardware",
  "Home Improvement",
  "Kitchen & Cookware",
  "Building Products",
  "Electrical",
  "Plumbing",
  "Tools & Equipment",
  "Other",
];

export const MEDIA = {
  hero: "https://images.unsplash.com/photo-1740914994657-f1cdffdc418e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  hardware: "https://images.unsplash.com/photo-1532550256335-c281a64ac9f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  amazon: "https://images.pexels.com/photos/7362924/pexels-photo-7362924.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  warehouse: "https://images.pexels.com/photos/36217325/pexels-photo-36217325.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  logistics: "https://images.pexels.com/photos/4483610/pexels-photo-4483610.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const CONTACT = {
  phone: "(657) 768-2609",
  email: "nathan@haysholdingsinc.com",
  address: "Anaheim, CA",
};
